const interestByPath = {
	"/cells/porcine-ipsc/": "Porcine iPSC",
	"/cells/bovine-esc/": "Bovine ESC",
	"/cells/ovine-ipsc/": "Ovine iPSC",
	"/cells/ovine-esc/": "Ovine ESC",
};

function normalizePathname(pathname) {
	if (!pathname) {
		return "/";
	}

	const normalizedPath = pathname.endsWith("/") ? pathname : `${pathname}/`;
	return normalizedPath.toLowerCase();
}

function getInterestValue(pathname) {
	return interestByPath[normalizePathname(pathname)] || null;
}

function preselectInterestCheckbox(formBlock, interestValue) {
	const interestInputs = formBlock.querySelectorAll(
		'input[type="checkbox"][name="interests[]"]'
	);

	if (!interestInputs.length) {
		return;
	}

	interestInputs.forEach((input) => {
		input.checked = input.value === interestValue;
	});
}

function initCellProductForm(formBlock) {
	const interestValue = getInterestValue(window.location.pathname);

	if (!interestValue) {
		return;
	}

	preselectInterestCheckbox(formBlock, interestValue);
}

function initCellProductForms() {
	const formBlocks = document.querySelectorAll(".cell-product-form");

	if (!formBlocks.length) {
		return;
	}

	formBlocks.forEach(initCellProductForm);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCellProductForms, {
		once: true,
	});
} else {
	initCellProductForms();
}
